
import { AppTheme } from '../theme';


export const createLoginLayoutStyles = (theme: AppTheme) => {
    return {
        container: {
            height: '100vh',
        },
    }
};
